jQuery(function($) {

    function isMobile(){
        return navigator.userAgent.match( /(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i );
    }

    
    function ScrollHeader(scroll) {
        if ( scroll >= 100 ) {
            $('.site-top').addClass('site-top--scroll');
            $('.custom-logo-link').addClass('active');
        } else {
            $('.site-top').removeClass('site-top--scroll');
            $('.custom-logo-link').removeClass('active');
        }
    }
    
    // Language Menu e.preventDefault(); 
    $('.menu li.menu-item-has-children').hoverIntent(function() {
        $(this).first().addClass('open');
        $(this).find('.sub-menu').first().slideDown();
    }, function() {
        $(this).first().removeClass('open');
        $(this).find('.sub-menu').first().slideUp();
    });

    // MENU MENU -- NO reloads
    $('.menu li.no-reload > a, .cm-linklist__wrapper li.no-reload > a').on('click', function(e) {
        e.preventDefault();
    });

    // Sidebar Menu
    $('.cm-linklist__wrapper li.menu-item-has-children').hoverIntent(function() {
        $(this).first().addClass('open');
        $(this).find('.sub-menu').first().fadeIn();
    }, function() {
        $(this).first().removeClass('open');
        $(this).find('.sub-menu').first().fadeOut();
    });

    // Scroll Header
    $(window).on('scroll', function() {    
        var scroll = $(window).scrollTop();
        ScrollHeader(scroll);
    });

    ScrollHeader( window.scrollY );


    // LANG SWITCH < mobile
    var $mobileMenu = $('#wprmenu_menu_ul');
    var $switcher   = $('li.menu-item--language');

    if( isMobile() ) {
        $mobileMenu.prepend( $switcher );
    }

});